module.exports = "img/flags/GH.13ac7cc.png";